module.exports = __webpack_public_path__ + "static/img/allinone-logo.1342cf8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/allinone-logo.svg
// module id = 0d3F
// module chunks = 0